export default "__VITE_ASSET__BuE4t6db__"